export const matchNamesSizes = [
  {
    width: 100,
    height: 12,
  },
  {
    width: 8,
    height: 12,
  },
  {
    width: 8,
    height: 12,
  },
  {
    width: 100,
    height: 12,
  },
  {
    width: 8,
    height: 12,
  },
  {
    width: 8,
    height: 12,
  },
];

export const matchInfoSizes = [
  {
    width: 13,
    height: 12,
  },
  {
    width: 91,
    height: 12,
  },
];

export const rightCellSizes = [
  {
    width: 120,
    height: 57,
  },
  {
    width: 120,
    height: 57,
  },
  {
    width: 120,
    height: 57,
  },
  {
    width: 22,
    height: 12,
  },
];

export const favoriteIconSize = 14;
